import { ReactNode } from 'react';
import { useRecoilState } from 'recoil';
import modalOpenAtom from './lxModalAtom';

const useDialog = () => {
  const [modalValue, setModalValue] = useRecoilState(modalOpenAtom);

  const openDialog = (child: ReactNode) => {
    setModalValue((prev) => {
      return { ...prev, isOpen: true, child: child };
    });
  };

  const closeDialog = () => {
    closeSelector();
    setModalValue((prev) => {
      return { ...prev, isOpen: false, child: null };
    });
  };

  const closeSelector = () => {
    const overlayContainer = document.getElementById('lxSelectorContainer');
    if (overlayContainer) {
      overlayContainer.innerHTML = '';
    }
  };

  return {
    isOpen: modalValue.isOpen,
    child: modalValue.child,
    openDialog,
    closeDialog,
  };
};

export default useDialog;
